import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import LoanSizingPageUI from './LoanSizingPageUI.js'

class LoanSizingPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loan: null,
      errorList: null,
      loanCheckList: null,
      loanSizingClassicList: null,
      loanSizing2: null,
      loanSizingSmallList: null,
      loanSizingSmall2: null,
      provisionalYear: null,
      showAllYears: false,
      // remarks
      updateRemarksMode: false,
      objectCode: null,
      objectId: null,
      selectedRemarks: null,
      selectedloanClassic2Remarks: null,
      objectFlavor: null,
      // details
      showDetailsMode: false,
      editable: false
    }
  }

  render() {
    return (
      <LoanSizingPageUI
        context={this.props.context}
        loan={this.state.loan}
        errorList={this.state.errorList}
        loanCheckList={this.state.loanCheckList}
        loanSizingClassicList={this.state.loanSizingClassicList}
        loanSizing2={this.state.loanSizing2}
        loanSizingSmallList={this.state.loanSizingSmallList}
        loanSizingSmall2={this.state.loanSizingSmall2}
        provisionalYear={this.state.provisionalYear}
        onRefreshClick={this.onRefreshClick}
        showAllYears={this.state.showAllYears}
        onShowAllClick={() => { this.setState({ showAllYears: true }) }}
        onShowRecentClick={() => { this.setState({ showAllYears: false }) }}
        //
        updateRemarksMode={this.state.updateRemarksMode}
        onCancelRemarksClick={() => { this.setState({ updateRemarksMode: false }) }}
        objectCode={this.state.objectCode}
        objectId={this.state.objectId}
        selectedRemarks={this.state.selectedRemarks}
        selectedloanClassic2Remarks={this.state.selectedloanClassic2Remarks}
        onUpdateRemarksClick={this.onUpdateRemarksClick}
        //
        showDetailsMode={this.state.showDetailsMode}
        onShowDetails={this.onShowDetails}
        //
        toggleEditable={() => { this.setState({ editable: !this.state.editable }) }}
        editable={this.state.editable}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getLoanSizingClassic2(context)
    this.getLoanSizingSmall2(context)
  }

  getLoanSizingClassic(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/sizing/classic`,
      cacheKey: CacheKeys.LoanSizingClassic(this.props.match.params.loanId),
      callback: this.getLoanSizingClassicCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanSizingClassicCallback = (response) => {
    this.setState({
      loanSizingClassicList: response.loanSizingList,
      provisionalYear: response.provisionalYear,
      errorList: response.errorList
    })
  }

  getLoanSizingClassic2(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/sizing/classic/2`,
      cacheKey: CacheKeys.LoanSizingClassic2(this.props.match.params.loanId),
      callback: this.getLoanSizingClassic2Callback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanSizingClassic2Callback = (response) => {
    this.setState({
      loanSizing2: response.loanSizing2,
      errorList: response.errorList
    })
  }

  getLoanSizingSmall(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/sizing/small`,
      cacheKey: CacheKeys.LoanSizingSmall(this.props.match.params.loanId),
      callback: this.getLoanSizingSmallCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanSizingSmallCallback = (response) => {
    this.setState({
      loanSizingSmallList: response.loanSizingList,
      provisionalYear: response.provisionalYear,
      errorList: response.errorList
    })
  }

  getLoanSizingSmall2(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/sizing/small/2`,
      cacheKey: CacheKeys.LoanSizingSmall2(this.props.match.params.loanId),
      callback: this.getLoanSizingSmall2Callback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanSizingSmall2Callback = (response) => {
    this.setState({
      loanSizingSmall2: response.loanSizingSmallLoan2,
      errorList: response.errorList
    })
  }

  getLoanCheck(context, loanParam) {
    let loan = loanParam ? loanParam : this.state.loan
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${loan.account.accountId}/loans/check`,
      cacheKey: CacheKeys.LoanCheck(loan.account.accountId),
      callback: this.getLoanCheckCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCheckCallback = (response) => {
    this.setState({
      loanCheckList: response.loanCheckList,
      provisionalYear: response.provisionalYear,
      errorList: response.errorList
    })
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
    // this.getLoanCheck(context, response.loan)
  }

  onUpdateRemarksClick = (event) => {
    let objectCode = event.currentTarget.getAttribute('data-object-code')
    let objectId = event.currentTarget.getAttribute('data-object-id')
    let objectFlavor = event.currentTarget.getAttribute('data-object-flavor')
    console.log(objectCode, objectId, objectFlavor);
    this.setState({
      updateRemarksMode: true,
      objectCode: objectCode,
      objectId: objectId,
      selectedRemarks: objectFlavor === 'classic' ? this.state.loanSizingClassicList[objectId + 'Remarks'] :
        this.state.loanSizingSmallList[objectId + 'Remarks'],
      selectedloanClassic2Remarks: this.state.loanSizing2[objectId + 'Remarks'],
      objectFlavor: objectFlavor
    })
  }

  onShowDetails = () => {
    if (this.state.showDetailsMode)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      showDetailsMode: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.state.loan.account.accountId}/scoreParameters/provisionals`,
      this.onShowDetailsCallback, {}
    )
  }

  onShowDetailsCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      showDetailsMode: false
    })

    if (response.errorList.length === 0) {
      this.getScoreParameters(this.props.context)
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
      }, 2000)
    }
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.LoanSizingClassic2(this.props.match.params.loanId))
    CacheManager.removeObject(CacheKeys.LoanSizingSmall2(this.props.match.params.loanId))
    this.setState({
      loanSizing2: null,
      loanSizingSmall2: null,
    },
      () => {
        this.getLoanSizingClassic2(context)
        this.getLoanSizingSmall2(context)
      }
    )
  }
}

export default withRouter(LoanSizingPageSF)
